import Link from '@mui/material/Link';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

const base = `${process.env.PUBLIC_URL}/assets/SVG`;

const LOGO_URLS = {
  BLACK_INVERT_FULL_BONE: `${base}/Logo_Bone_Black_Inverse.svg`,
  BLACK_INVERT_FULL: `${base}/Logo_Black_Inverse.svg`,
  BLACK_FULL: `${base}/Logo_Black.svg`,
  BLACK_FULL_BONE: `${base}/Logo_Bone_Black.svg`,
  BLUE_INVERT_FULL_BONE: `${base}/Logo_Bone_Blue_Inverse.svg`,
  BLUE_INVERT_FULL: `${base}/Logo_Blue_Inverse.svg`,
  BLUE_FULL: `${base}/Logo_Blue.svg`,
  BLUE_FULL_BONE: `${base}/Logo_Bone_Blue.svg`
};

export enum LogoType {
  BLACK_INVERT_FULL_BONE = 'BLACK_INVERT_FULL_BONE',
  BLACK_INVERT_FULL = 'BLACK_INVERT_FULL',
  BLACK_FULL = 'BLACK_FULL',
  BLACK_FULL_BONE = 'BLACK_FULL_BONE',
  BLUE_INVERT_FULL_BONE = 'BLUE_INVERT_FULL_BONE',
  BLUE_INVERT_FULL = 'BLUE_INVERT_FULL',
  BLUE_FULL = 'BLUE_FULL',
  BLUE_FULL_BONE = 'BLUE_FULL_BONE',
}

export interface ILogo {
  logo?: LogoType;
  to?: string;
  width?: number;
}

export function Logo(props: ILogo) {
  const { to, width, logo } = { to: '/', width: 90, logo: LogoType.BLUE_INVERT_FULL_BONE, ...props };
  return (
    <Link component={RouterLink} to={to}
          sx={{
            width: width,
            cursor: 'pointer',
            transform: 'scale(1)',
            transition: (theme) => theme.transitions.create(['transform'], {
              duration: theme.transitions.duration.standard
            }),
            '&:hover': {
              transform: 'scale(1)'
            }
          }}
    >
      <img src={LOGO_URLS[logo]} alt="Logo" style={{ width: width }}/>
    </Link>
  );

}
